// import * as selectors from './selectors';
import { actions, reducer } from './slice';

export { actions, reducer };
